module.exports = __webpack_public_path__ + "static/boneclaw-ca668ffe430492885c4457ad9756510d.png";